import script from "./RunningGame.vue?vue&type=script&setup=true&lang=js"
export * from "./RunningGame.vue?vue&type=script&setup=true&lang=js"

import "./RunningGame.vue?vue&type=style&index=0&id=074f9d09&scoped=true&lang=css"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-074f9d09"]])

export default __exports__